import styles from "./SelectField.module.css";

const SelectField = ({

    id,

    name,

    label,

    icon,

    value = "",

    options = [],

    placeholder = "انتخاب کنید",

    error,

    touched,

    hint,

    required = false,

    disabled = false,

    onChange,

    onBlur,

}) => {

    const hasError = Boolean(error && touched);

    const handleChange = (e) => {

        onChange(e.target.value);

    };

    return (

        <div
            className={`${styles.wrapper} ${
                hasError
                    ? styles.error
                    : ""
            }`}
        >

            <div className={styles.label}>

                {

                    icon &&

                    <span className={styles.icon}>
                        {icon}
                    </span>

                }

                <span>

                    {label}

                    {

                        required &&

                        <small>*</small>

                    }

                </span>

            </div>

            <select

                id={id}

                name={name}

                value={value}

                disabled={disabled}

                onChange={handleChange}

                onBlur={onBlur}

                className={styles.select}

            >

                <option value="">

                    {placeholder}

                </option>

                {

                    options.map((item)=>(

                        <option

                            key={item.value}

                            value={item.value}

                        >

                            {item.label}

                        </option>

                    ))

                }

            </select>

            {

                hint &&

                !hasError &&

                <div className={styles.hint}>

                    {hint}

                </div>

            }

            {

                hasError &&

                <div className={styles.errorText}>

                    {error}

                </div>

            }

        </div>

    );

};

export default SelectField;